"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: underwriting/evaluation-results.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Funderwriting%2Fevaluation-results.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationMetadata = exports.EvaluationResult = exports.EvaluationResultsProduct = exports.EvaluationResults = void 0;
const lending_eligibility_1 = require("../common/lending-eligibility");
const lending_risk_level_1 = require("../ml/lending-risk-level");
const protobufPackage = 'com.step.underwriting.common.proto';
function createBaseEvaluationResults() {
    return { products: [] };
}
exports.EvaluationResults = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.products)) {
            message.products = object.products.map((e) => exports.EvaluationResultsProduct.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.products?.length) {
            obj.products = message.products.map((e) => exports.EvaluationResultsProduct.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.EvaluationResults.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluationResults();
        message.products = object.products?.map((e) => exports.EvaluationResultsProduct.fromPartial(e)) || [];
        return message;
    },
};
function createBaseEvaluationResultsProduct() {
    return { bnpl: undefined, flex: undefined };
}
exports.EvaluationResultsProduct = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.bnpl)) {
            message.bnpl = exports.EvaluationResult.fromJSON(object.bnpl);
        }
        if (isSet(object.flex)) {
            message.flex = exports.EvaluationResult.fromJSON(object.flex);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bnpl !== undefined) {
            obj.bnpl = exports.EvaluationResult.toJSON(message.bnpl);
        }
        if (message.flex !== undefined) {
            obj.flex = exports.EvaluationResult.toJSON(message.flex);
        }
        return obj;
    },
    create(base) {
        return exports.EvaluationResultsProduct.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluationResultsProduct();
        message.bnpl = (object.bnpl !== undefined && object.bnpl !== null)
            ? exports.EvaluationResult.fromPartial(object.bnpl)
            : undefined;
        message.flex = (object.flex !== undefined && object.flex !== null)
            ? exports.EvaluationResult.fromPartial(object.flex)
            : undefined;
        return message;
    },
};
function createBaseEvaluationResult() {
    return {
        metadata: undefined,
        denialReasonCodes: [],
        lendingRiskLevel: lending_risk_level_1.LendingRiskLevel.INVALID_LENDING_RISK_LEVEL,
        referenceId: '',
        score: undefined,
        modelVersion: undefined,
    };
}
exports.EvaluationResult = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.metadata)) {
            message.metadata = exports.EvaluationMetadata.fromJSON(object.metadata);
        }
        if (globalThis.Array.isArray(object?.denialReasonCodes)) {
            message.denialReasonCodes = object.denialReasonCodes.map((e) => (0, lending_eligibility_1.lendingDenialReasonFromJSON)(e));
        }
        if (isSet(object.lendingRiskLevel)) {
            message.lendingRiskLevel = (0, lending_risk_level_1.lendingRiskLevelFromJSON)(object.lendingRiskLevel);
        }
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        if (isSet(object.score)) {
            message.score = globalThis.Number(object.score);
        }
        if (isSet(object.modelVersion)) {
            message.modelVersion = globalThis.String(object.modelVersion);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.metadata !== undefined) {
            obj.metadata = exports.EvaluationMetadata.toJSON(message.metadata);
        }
        if (message.denialReasonCodes?.length) {
            obj.denialReasonCodes = message.denialReasonCodes.map((e) => (0, lending_eligibility_1.lendingDenialReasonToJSON)(e));
        }
        if (message.lendingRiskLevel !== undefined &&
            message.lendingRiskLevel !== lending_risk_level_1.LendingRiskLevel.INVALID_LENDING_RISK_LEVEL) {
            obj.lendingRiskLevel = (0, lending_risk_level_1.lendingRiskLevelToJSON)(message.lendingRiskLevel);
        }
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.score !== undefined) {
            obj.score = message.score;
        }
        if (message.modelVersion !== undefined) {
            obj.modelVersion = message.modelVersion;
        }
        return obj;
    },
    create(base) {
        return exports.EvaluationResult.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluationResult();
        message.metadata = (object.metadata !== undefined && object.metadata !== null)
            ? exports.EvaluationMetadata.fromPartial(object.metadata)
            : undefined;
        message.denialReasonCodes = object.denialReasonCodes?.map((e) => e) || [];
        message.lendingRiskLevel = object.lendingRiskLevel ??
            lending_risk_level_1.LendingRiskLevel.INVALID_LENDING_RISK_LEVEL;
        message.referenceId = object.referenceId ?? '';
        message.score = object.score ?? undefined;
        message.modelVersion = object.modelVersion ?? undefined;
        return message;
    },
};
function createBaseEvaluationMetadata() {
    return { referenceId: '', modelVersion: '', score: 0 };
}
exports.EvaluationMetadata = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        if (isSet(object.modelVersion)) {
            message.modelVersion = globalThis.String(object.modelVersion);
        }
        if (isSet(object.score)) {
            message.score = globalThis.Number(object.score);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.modelVersion !== undefined && message.modelVersion !== '') {
            obj.modelVersion = message.modelVersion;
        }
        if (message.score !== undefined && message.score !== 0) {
            obj.score = message.score;
        }
        return obj;
    },
    create(base) {
        return exports.EvaluationMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEvaluationMetadata();
        message.referenceId = object.referenceId ?? '';
        message.modelVersion = object.modelVersion ?? '';
        message.score = object.score ?? 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=evaluation-results.js.map